import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";

import OuterClickListener from "@components/outer-click-listener";

import DropdownOptionContent from "./DropdownOptionContent";

import { setLocale, getSelectedLocale } from "../../utils/locale";

import { config, defaultConfig } from "./consts";

import styles from "./LanguageSelect.scss";

const cx = classnames.bind(styles);

const LanguageSelect = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [locale, setLocaleValue] = useState("ru");
  const [localeList, setLocaleList] = useState({});

  const toggleDropdownIsOpen = (event) => {
    event.stopPropagation();

    if (Object.keys(localeList).length === 0) {
      const footerElement = document.querySelector("[data-app=footer]");

      let availableLocales = defaultConfig;
      if (footerElement) {
        const availableLocalesString = footerElement.getAttribute(
          "data-available-locales"
        );

        if (availableLocalesString) {
          availableLocales = availableLocalesString
            .split(",")
            .filter((localeName) => !!config[localeName])
            .map((localeName) => config[localeName]);
        }
      }

      setLocaleList(availableLocales);
    }

    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const changePageLanguage = (nextLocale) => {
    if (window && window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push({ event: `select-${nextLocale}-lang` });
    }

    closeDropdown();
    setLocale(nextLocale);
  };

  useEffect(() => {
    setLocaleValue(getSelectedLocale());
  }, []);

  return (
    <div className={cx("wrapper")}>
      <button
        className={cx("main-button", isOpen && "active")}
        onClick={toggleDropdownIsOpen}
      >
        <DropdownOptionContent option={config[locale]} />
        <svg
          className={cx("triangle-icon")}
          width={10}
          height={5}
          fill="var(--glz-color-neutral-tone-4)"
        >
          <use
            href={`#${
              isOpen ? "ic_arrow-triangle-up" : "ic_arrow-triangle-down"
            }`}
          />
        </svg>
      </button>
      {isOpen && (
        <OuterClickListener onClickOutside={closeDropdown}>
          <div className={cx("dropdown")}>
            {Object.values(localeList).map((option) => (
              <button
                className={cx("option-button")}
                key={option.value}
                onClick={() => {
                  changePageLanguage(option.value);
                }}
              >
                <DropdownOptionContent option={option} />
              </button>
            ))}
          </div>
        </OuterClickListener>
      )}
    </div>
  );
};

export default LanguageSelect;
